"use strict";

function getAttribute(parsed, tagname, attr) {
  var result = null;
  var regex = new RegExp("<[\\s\\S]*\\s".concat(attr, "=\"([^\"]*)\"[\\s\\S]*$"));
  parsed.some(function (p) {
    if (p.type === "tag" && p.value.indexOf("<".concat(tagname, " ")) !== -1 && regex.test(p.value)) {
      result = p.value.replace(regex, "$1");
      return true;
    }
    return false;
  });
  if (!result) {
    return null;
  }
  return result;
}
function getAttributes(parsed, tagname, attr) {
  var result = [];
  var regex = new RegExp("<[\\s\\S]*\\s".concat(attr, "=\"([^\"]*)\"[\\s\\S]*$"));
  parsed.forEach(function (p) {
    if (p.type === "tag" && p.value.indexOf("<".concat(tagname, " ")) !== -1 && regex.test(p.value)) {
      result.push(p.value.replace(regex, "$1"));
    }
  });
  return result;
}
function removeSingleAttribute(partValue, attr) {
  var regex = new RegExp("(<[\\s\\S]*)\\s".concat(attr, "=\"[^\"]*\"([\\s\\S]*)$"));
  if (regex.test(partValue)) {
    return partValue.replace(regex, "$1$2");
  }
  return partValue;
}
function setSingleAttribute(partValue, attr, attrValue) {
  if (attr instanceof Object && attrValue == null) {
    Object.keys(attr).forEach(function (key) {
      partValue = setSingleAttribute(partValue, key, attr[key]);
    });
    return partValue;
  }
  var regex = new RegExp("(<[\\s\\S]*\\s".concat(attr, "=\")([^\"]*)(\"[\\s\\S]*)$"));
  if (regex.test(partValue)) {
    return partValue.replace(regex, "$1".concat(attrValue, "$3"));
  }
  var end = partValue.lastIndexOf("/>");
  if (end === -1) {
    end = partValue.lastIndexOf(">");
  }
  return partValue.substr(0, end) + " ".concat(attr, "=\"").concat(attrValue, "\"") + partValue.substr(end);
}
function setAttribute(parsed, tagname, attr, value) {
  var regex = new RegExp("(<[\\s\\S]*\\s".concat(attr, "=\")([^\"]+)(\"[\\s\\S]*)$"));
  var found = parsed.some(function (p) {
    if (p.type === "tag" && p.value.indexOf("<" + tagname) !== -1) {
      if (regex.test(p.value)) {
        p.value = p.value.replace(regex, "$1".concat(value, "$3"));
      } else {
        var end = p.value.lastIndexOf("/>");
        if (end === -1) {
          end = p.value.lastIndexOf(">");
        }
        p.value = p.value.substr(0, end) + " ".concat(attr, "=\"").concat(value, "\"") + p.value.substr(end);
      }
      return true;
    }
    return false;
  });
  if (!found) {
    var err = new Error("Attribute not found");
    err.properties = {
      parsed: parsed,
      tagname: tagname,
      attr: attr
    };
    throw err;
  }
  return parsed;
}
function getSingleAttribute(value, attributeName) {
  // We use \\s\\S instead of ".*" to include "\n" which are allowed inside xml tags.
  // See https://stackoverflow.com/questions/1979884/how-to-use-javascript-regex-over-multiple-lines
  var regex = new RegExp("(<[\\s\\S]*\\s".concat(attributeName, "=\")([^\"]+)(\"[\\s\\S]*)$"));
  if (!regex.test(value)) {
    return null;
  }
  return value.replace(regex, "$2");
}
function getSingleNumAttribute(value, attributeName) {
  return parseFloat(getSingleAttribute(value, attributeName));
}
function getIntAttribute(parsed, tagName, attr) {
  var value = getAttribute(parsed, tagName, attr);
  return value ? parseInt(value, 10) : null;
}
module.exports = {
  getAttribute: getAttribute,
  getAttributes: getAttributes,
  getIntAttribute: getIntAttribute,
  getSingleAttribute: getSingleAttribute,
  getSingleNumAttribute: getSingleNumAttribute,
  setAttribute: setAttribute,
  setSingleAttribute: setSingleAttribute,
  removeSingleAttribute: removeSingleAttribute
};